import types from './types';

export const startTrialVersion = () => ({ type: types.START_TRIAL_REQUEST });

